import React from 'react';

const SponDirt = () => {
  return (
    <div className="SponDirt">
      <div className="free-donut-right">
      </div>
      <div className="free-donut-left">
      </div>
      <div className="free-donut-left-2">
      </div>
      <div className="free-donut-left-3">
      </div>
    </div>
  )
}

export default SponDirt;